document.addEventListener('DOMContentLoaded', function() {
  const select = document.getElementById("topics_of_inquiry_select");
  select?.addEventListener('change', function() {
    let selectWrapper = this.closest('.topic-of-inquiry-input-field-wrapper');
    if (this.value !== "" && !selectWrapper.classList.contains('has-selected')) {
      selectWrapper.classList.add('has-selected');
    }
  });
});

class contactForm extends HTMLElement {
  constructor() {
    super();
    this.submitBtn = this.querySelector('button[type="button"]');
    this.form = this.querySelector('form');
    this.isSubmitting = false; // Prevent multiple submissions
  }

  connectedCallback() {
    this.submitBtn.addEventListener('click', this.submitForm.bind(this));
  }

  disconnectedCallback() {
    this.submitBtn.removeEventListener('click', this.submitForm);
  }

  async submitForm(e) {
    e.preventDefault();

    // Prevent multiple submissions
    if (this.isSubmitting) {
      console.warn("Form is already submitting...");
      return;
    }

    if (!this.validateFormFields()) {
      this.isSubmitting = true;
      this.submitBtn.classList.add('loading');
      this.submitBtn.disabled = true; // Disable the button immediately

      const formData = new FormData(this.form);
      const entries = formData.entries();
      const data = Object.fromEntries(entries);

      try {
        await this.sendData(data);

        // Redirect after successful submission
        window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
      } catch (error) {
        console.error("Form submission error:", error);
        alert("There was a problem submitting your form. Please try again.");
        this.isSubmitting = false;
        this.submitBtn.disabled = false; // Re-enable button on error
      } finally {
        this.submitBtn.classList.remove('loading');
      }
    }
  }

  validateFormFields() {
    let error = false;
    let inputs = this.querySelectorAll('.field__input');

    inputs.forEach(input => {
      let emptyFieldError = input.closest('.field').querySelector('.empty-field-error');
      let invalidEmailError = input.closest('.field').querySelector('.invalid-email-error');

      if (input.required === true) {
        if (input.value !== "") {
          if (!emptyFieldError.classList.contains('hidden')) {
            emptyFieldError.classList.add('hidden');
          }
          if (input.classList.contains('email-field')) {
            if (this.validateEmail(input.value)) {
              invalidEmailError.classList.add('hidden');
            } else {
              error = true;
              invalidEmailError.classList.remove('hidden');
            }
          }
        } else {
          error = true;
          emptyFieldError?.classList.remove('hidden');
        }
      }
    });

    return error;
  }

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  }

async sendData(data) {
  try {
    const response = await fetch('https://middleware-bridge.gadget.app/api/contact', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response || (response.status !== 200 && response.status !== 201)) {
      console.error('Server error:', response.status, await response.text());
      // Remove throwing error here, just log it
    }

  } catch (error) {
    console.error("Form submission error:", error);
    // No need to throw again
  }
}
}

if (!customElements.get("contact-form")) {
  customElements.define("contact-form", contactForm);
}

// Contact form success message handling
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    const successMessage = document.querySelector('#ContactForm .contact-form__message');
    if (successMessage) {
      successMessage.classList.remove('hidden');
    }
  }
});

// document.addEventListener('DOMContentLoaded', function() {
//   const select = document.getElementById("topics_of_inquiry_select");
//   select?.addEventListener('change', function() {
//     let selectWrapper = this.closest('.topic-of-inquiry-input-field-wrapper');
//     if(this.value != "" && !selectWrapper.classList.contains('has-selected')) {
//       selectWrapper.classList.add('has-selected');
//     }
//   });
// });
// class contactForm extends HTMLElement {
//   constructor() {
//     super();
//     this.submitBtn = this.querySelector('button[type="button"]');
//     this.form = this.querySelector('form');
//   }
//   connectedCallback() {
//     this.submitBtn.addEventListener('click',this.submitForm.bind(this));
//   }
//   disconnectedCallBack() {
//     this.submitBtn.removeEventListener('click',this.submitForm);
//   }

//   async submitForm(e) {
//     e.preventDefault();
//     if (!this.validateFormFields()) {
//         this.submitBtn.classList.add('loading');
//         const formData = new FormData(this.form);
//         const entries = formData.entries();
//         const data = Object.fromEntries(entries);

//         try {
//             // Call sendData and wait for it to complete
//             await this.sendData(data);
//             // Show success alert after data is sent
//             window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
//         } catch (error) {
//             // Handle error if sendData fails
//             window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
//         } finally {
//             this.submitBtn.classList.remove('loading');
//         }
//     }
// }

// //   async submitForm(e) {
// //   e.preventDefault();
// //   if (!this.validateFormFields()) {
// //     this.submitBtn.classList.add('loading');
// //     const formData = new FormData(this.form);
// //     const entries = formData.entries();
// //     const data = Object.fromEntries(entries);

// //     try {
// //       await this.sendData(data);

// //       // Redirect only after successful API response
// //       window.location.href = `${window.location.origin}${window.location.pathname}?contact_posted=true#ContactForm`;
// //     } catch (error) {
// //       console.error("Form submission error:", error);
// //       alert("There was a problem submitting your form. Please try again.");
// //     } finally {
// //       this.submitBtn.classList.remove('loading');
// //     }
// //   }
// // }

//   validateFormFields() {
//     let error = false;
//     let inputs = this.querySelectorAll('.field__input');
//     inputs.forEach(input => {
//       let emptyFieldError = input.closest('.field').querySelector('.empty-field-error');
//       let invalidEmailError = input.closest('.field').querySelector('.invalid-email-error');
//       if (input.required === true) {
//         if(input.value != "") {
//           if(!emptyFieldError.classList.contains('hidden')) {
//             emptyFieldError.classList.add('hidden');
//           }
//           if(input.classList.contains('email-field')) {
//             if(this.validateEmail(input.value)) {
//               invalidEmailError.classList.add('hidden');
//             }
//             else {
//               error = true;
//               invalidEmailError.classList.remove('hidden');
//             }
//           }
//         }
//         else {
//           error = true;
//           input.closest('.field').querySelector('.empty-field-error')?.classList.remove('hidden');
//         }
//       }
//     });
//     return error;
//   }

//   validateEmail(email) {
//     const re =
//       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     return re.test(email.toLowerCase());
//   }

//   async sendData(data) {
//     let response = await fetch('https://middleware-bridge.gadget.app/api/contact', {
//       method: "POST",
//       headers: {
//       'Content-Type':'application/json'
//       },
//         body: JSON.stringify(data)
//       });
//     if(response.ok) {
//       this.submitBtn.classList.remove('loading');
//       this.querySelector('button[type="button"]').click();
//     }
//   }
// // async sendData(data) {
// //   try {
// //     let response = await fetch('https://middleware-bridge.gadget.app/api/contact', {
// //       method: "POST",
// //       mode: "no-cors",
// //       headers: {
// //         'Content-Type': 'application/json'
// //       },
// //       body: JSON.stringify(data)
// //     });

// //     if (!response.ok) {
// //       console.error('Server responded but not OK:', response.status, await response.text());
// //       throw new Error('API response not OK');
// //     }

// //     this.submitBtn.classList.remove('loading');
// //     this.querySelector('button[type="button"]').click();
// //   } catch (err) {
// //     console.error("Form submission error:", err);
// //     throw err;
// //   }
// // }
// }

// if (!customElements.get("contact-form")) {
//   customElements.define("contact-form", contactForm);
// }
// // Check if the URL has 'postedtrue' parameter and remove the 'hidden' class
// document.addEventListener('DOMContentLoaded', function() {
//   // Check if the URL contains '?contact_posted=true'
//   if (window.location.search.indexOf('contact_posted=true') !== -1) {
//       const successMessage = document.querySelector('#ContactForm .contact-form__message');
//       if (successMessage) {
//           successMessage.classList.remove('hidden');
//       }
//   }
// });